<template>
  <div id="NLP">
    <div class="font">
      <span class="introSubTitle"><b>自然资源语言智能交互系统</b></span>
      <p class="textStyle">采用基于语音、自然语言理解与地理信息智能化处理技术，面向自然资源管理应用的普通用户，构建手机、电脑等终端上的典型自然资源应用系统交互“第一界面”，构建“所问即所见”、“即查即所见”的自然资源智能交互应用模式，构建普通用户与行业数据管理系统之间的“智能中间件”，实现对土地利用专题中对已供应土地、批而未供土地、拟供应土地和闲置土地的智能化查询，对老河口市违章建筑处置系统提供智能化查询接口，同时实现对地理国情、三调等数据的智能化化查阅。探索基于语音、自然语言的自然资源垂直搜索关键技术，构建遥感信息智能交互系统，实现普通用户对自然资源应用的人性化和智能化交互。</p>
    </div>
    <br/>
    <div class="container">
      <el-image :src="imgUrl"></el-image>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      imgUrl: require("@/assets/img/scientific/nlp.png"),
    };
  }
};
</script>

<style lang="less">
#NLP {
  margin-top: 20px;
  // .font {
  //   // font-family: "Times New Roman", Times, serif;
  // }
}
</style>
